export default {
  "config": {
    "trial": "tones-5",
    "id": "pgic-cgic",
    "type": "bar",
    "title": "Participants Reported as Worse at End of RW Phase (mITT Population)<sup>14</sup>",
    "xAxis": {
      "groups": [
        "pgic",
        "cgic"
      ],
      "padding": 0.1,
      "label": {},
      "overrides": {
        "pgic": "PGI-C",
        "cgic": "CGI-C"
      },
      "shadedRegion": [],
      "scale": "scaleBand",
      "tickLabelSpace": 28,
      "overridesOnAxis": true
    },
    "yAxis": {
      "low": 0,
      "high": 100,
      "inc": 10,
      "label": {
        "text": [
          "Participants reported as <no-break>worse, %</no-break>"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo",
        "label": "Placebo",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "combined",
        "label": "Solriamfetol (combined)<sup>a</sup>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol (combined)"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break><em><sup>#</sup>P</em> < 0.0001<no-break> vs placebo.",
      "<sup>a</sup>Solriamfetol doses include 37.5 mg, 75 mg, 150 mg, and 300 mg."
    ],
    "useFootnoteTooltip": false,
    "trendLines": [],
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "combined",
            "label": "Solriamfetol (combined)<sup>a</sup>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol (combined)"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "x": "pgic",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 64.5,
          "label": {
            "text": 64.5,
            "sup": "",
            "override": "<no-break>(n = 138)</no-break>"
          }
        },
        {
          "name": "combined",
          "color": "#006e8a",
          "y": 28.2,
          "label": {
            "text": 28.2,
            "sup": "#",
            "override": "<no-break>(n = 131)</no-break>"
          }
        }
      ]
    },
    {
      "x": "cgic",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 63.8,
          "label": {
            "text": 63.8,
            "sup": "",
            "override": "<no-break>(n = 141)</no-break>"
          }
        },
        {
          "name": "combined",
          "color": "#006e8a",
          "y": 28.7,
          "label": {
            "text": 28.7,
            "sup": "#",
            "override": "<no-break>(n = 136)</no-break>"
          }
        }
      ]
    }
  ]
};